import { z } from 'zod';
import { ENTITY_TYPES, LINK_TYPES, CANON_STATUSES, CONFIDENCES } from '@/types/entity';

const entityTypeSchema = z.enum(ENTITY_TYPES as [string, ...string[]]);
const linkTypeSchema = z.enum(LINK_TYPES as [string, ...string[]]);
const canonStatusSchema = z.enum(CANON_STATUSES as [string, ...string[]]);
const confidenceSchema = z.enum(CONFIDENCES as [string, ...string[]]);

export const fieldDefSchema = z.object({
  key: z.string().min(1),
  label: z.string(),
  type: z.enum([
    'text',
    'longtext',
    'select',
    'multiselect',
    'number',
    'date',
    'entityref',
    'tags',
  ]),
  options: z.array(z.string()).optional(),
  group: z.string().optional(),
  order: z.number().optional(),
  placeholder: z.string().optional(),
});

export const sourceRefSchema = z.object({
  kind: z.enum(['bible', 'manuscript', 'ai', 'external', 'note']),
  ref: z.string(),
  note: z.string().optional(),
});

export const entitySchema = z.object({
  id: z.string().min(1),
  type: entityTypeSchema,
  name: z.string(),
  aliases: z.array(z.string()).optional(),
  summary: z.string().optional(),
  fields: z.record(z.unknown()),
  customFields: z.array(fieldDefSchema).optional(),
  tags: z.array(z.string()).optional(),
  color: z.string().optional(),
  icon: z.string().optional(),
  refs: z.array(z.string()).optional(),
  meta: z.record(z.unknown()).optional(),
  canonStatus: canonStatusSchema,
  confidence: confidenceSchema,
  sourceRefs: z.array(sourceRefSchema).optional(),
  version: z.number().int().nonnegative(),
  deletedAt: z.number().optional(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export const linkSchema = z.object({
  id: z.string().min(1),
  from: z.string().min(1),
  to: z.string().min(1),
  type: linkTypeSchema,
  label: z.string().optional(),
  directed: z.boolean(),
  canonStatus: canonStatusSchema,
  confidence: confidenceSchema,
  version: z.number().int().nonnegative(),
  deletedAt: z.number().optional(),
});

export const plotColumnSchema = z.object({
  id: z.string(),
  label: z.string(),
  phase: z.string().optional(),
  order: z.number(),
});

export const projectSchema = z.object({
  id: z.string(),
  title: z.string(),
  schemaVersion: z.number().int(),
  plotColumns: z.array(plotColumnSchema),
  meta: z.record(z.unknown()),
  createdAt: z.number(),
  updatedAt: z.number(),
});

// 타입 추론이 우리 도메인 타입과 호환되는지 (구조적) — import 검증에 사용
export type EntityInput = z.infer<typeof entitySchema>;
export type LinkInput = z.infer<typeof linkSchema>;
export type ProjectInput = z.infer<typeof projectSchema>;
